<!--
 * @Author: huanglin.like@qq.com
 * @LastEditTime: 2024-04-19 10:10:58
-->
<template>
  <div>
    <com-page>
      <com-order-search @search="handleSearch" @onExport="handleExport"></com-order-search>
      <com-card>
        <div class="flex justify-between">
          <div class="flex items-start mb-5px">
            <h4 class="mt-12px">订单状态</h4>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane
                :label="item.label"
                :name="item.value"
                v-for="item in statusTag"
                :key="item.value"
              ></el-tab-pane>
            </el-tabs>
          </div>
          <el-button type="warning" style="height: 36px" @click="dialogVisible = true">卡订单修复</el-button>
        </div>
        <com-order-list ref="orderListRef" :defaultParams="defaultParams"></com-order-list>
      </com-card>
    </com-page>

    <com-dialog :visible.sync="dialogVisible" title="卡订单修复" width="40%">
      <div>
        <div class="flex items-center">
          <div>设备编号：</div>
          <el-input
            style="width: 300px;"
            placeholder="请输入设备编号"
            v-model="devSn"
          ></el-input>
        </div>
        <div class="flex items-center mt-15px">
          <div>端口号：</div>
          <el-input
            style="width: 300px;"
            placeholder="请输入端口号"
            v-model="devPort"
          ></el-input>
        </div>
        <div class="mt-15px flex items-center justify-end">
          <el-button type="" @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmFixDevice">确定</el-button>
        </div>
      </div>
    </com-dialog>
  </div>
</template>

<script>
import utils from 'my-tools-library'
import { resetDevice } from '@/api/order'

export default {
  data() {
    return {
      activeName: '0',
      statusTag: [
        {
          label: '全部',
          value: '0'
        },
        {
          label: '进行中',
          value: '1'
        },
        {
          label: '已完成',
          value: '2'
        },
        {
          label: '已退单',
          value: '3'
        }
      ],
      defaultParams: {
        status: ''
      },
      exportQuery: {},
      dialogVisible: false,
      devSn: '', // 设备编号
      devPort: '', // 设备端口
    }
  },
  methods: {
    handleClick() {
      this.defaultParams.status = +this.activeName === 0 ? '' : +this.activeName + 1

      if (+this.activeName === 3) {
        this.defaultParams.status = 6
      }
      this.$refs.orderListRef.init()
    },
    handleSearch(val) {
      this.exportQuery = { ...val }
      this.$refs.orderListRef.search(val)
    },
    async handleExport() {
      const params = {
        status: this.defaultParams.status,
        ...this.exportQuery
      }
      const obj = JSON.parse(JSON.stringify(params))
      let i = ''
      let url = ''
      // eslint-disable-next-line prefer-template, guard-for-in, no-restricted-syntax
      for (i in obj) url += '&' + i + '=' + obj[i]
      const downloadUrl = `${process.env.VUE_APP_REQUEST_URL}/chargePieOrder/exportExcel?${url}`
      utils.download(downloadUrl, '订单列表')
    },

    // 卡订单修复
    confirmFixDevice() {
      resetDevice(this.devSn, this.devPort).then((res) => {
        this.$message.success(res.desc)
        this.dialogVisible = false
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
